import React from "react";
import HcsControl from "./hcs-control";

export default class HcsButtonSubConfigFinish extends HcsControl {
    constructor(props) {
        super(props);

        this.buttonClick = this.buttonClick.bind(this);
    }

    buttonClick() {
        this.props.onConfig("exitCurrentCfgObject", null, null);
    }

    // override from base class
    isVisible() {
        return true;
    }

    // override from base class
    childClass() {
        return "hcs-subconfig-finish";
    }

    render() {
        const { data } = this.props;

        return super.render(
            <button
                onClick={this.buttonClick}
                className="hcs-button hcs-secondary hcs-subconfig-finish"
            >
                <span dangerouslySetInnerHTML={{ __html: data.info.trans }} />
            </button>
        );
    }
}